import { Component, input } from '@angular/core';

import { Locker } from '../../../models/domain.models';

@Component({
  selector: 'vx-map-preview',
  standalone: true,
  template: `
    <div class="map">
      @for (locker of lockers(); track locker.id; let i = $index) {
        <button class="pin" [class]="locker.stato" [style.left.%]="18 + i * 15" [style.top.%]="26 + (i % 3) * 18" [title]="locker.nome"></button>
      }
      <span class="label">Locker map preview</span>
    </div>
  `,
  styles: [`
    .map {
      min-height: 280px;
      position: relative;
      border-radius: 8px;
      overflow: hidden;
      background:
        linear-gradient(90deg, rgba(9,13,32,.04) 1px, transparent 1px),
        linear-gradient(rgba(9,13,32,.04) 1px, transparent 1px),
        radial-gradient(circle at 30% 20%, rgba(109,93,252,.18), transparent 18rem),
        #f7f9ff;
      background-size: 34px 34px, 34px 34px, auto, auto;
      border: 1px solid var(--vx-line);
    }
    .pin {
      position: absolute;
      width: 18px;
      height: 18px;
      border-radius: 999px;
      border: 3px solid white;
      background: var(--vx-primary);
      box-shadow: 0 0 0 8px rgba(109, 93, 252, 0.12), 0 10px 20px rgba(0,0,0,.18);
      cursor: pointer;
      animation: ping 2.4s ease infinite;
    }
    .pin.disponibile { background: var(--vx-success); }
    .pin.occupato { background: var(--vx-warning); }
    .pin.offline { background: var(--vx-danger); }
    .pin.manutenzione { background: #8b5cf6; }
    .label {
      position: absolute;
      left: 16px;
      bottom: 16px;
      padding: 9px 12px;
      border-radius: 8px;
      background: white;
      font-weight: 900;
      box-shadow: 0 8px 24px rgba(14,23,60,.1);
    }
    @keyframes ping {
      50% { transform: translateY(-4px); }
    }
  `]
})
export class MapPreviewComponent {
  lockers = input.required<Locker[]>();
}
